import {
  put, call,
} from 'redux-saga/effects';

import { api, urls } from 'api/request';
import types from './types';

export function* fetchProjectsSaga() {
  const response = yield call(api.get, urls.getProjects);

  if (!response.error) {
    yield put({ type: types.GET_PROJECTS_SUCCESS, payload: response.data });
  } else {
    yield put({ type: types.GET_PROJECTS_ERROR });
  }
}



// WEBPACK FOOTER //
// ./src/view/duck/saga.js